import React, { useEffect, useState } from "react";
import "./product.css"
import { formatConfidence, formatLift, formatSupport, getBundleTags } from "../../../../common/common";
import { setTotalBundles,setAvgItemPerBundle,setAvgConversionRate,setSearchQueryForItemsets,setSortBy } from "../../../../../store";
import { useDispatch,useSelector } from "react-redux";

const ProductBundles = ({ productBundlesData, totalTransactions, customeValueData }) => {
    const dispatch = useDispatch();
    const totalBundles = useSelector((state) => state.analysisData.totalBundles);
    const avgItemPerBundle = useSelector((state) => state.analysisData.avgItemPerBundle);
    const avgConversionRate = useSelector((state) => state.analysisData.avgConversionRate);
    const searchQueryForItemsets = useSelector((state) => state.analysisData.searchQueryForItemsets);
    const sortBy = useSelector((state) => state.analysisData.sortBy);



    const [productsBundles, setProductBundles] = useState([]);
    const [withoutFilterProductBundles,setWithoutFilterProductBundles] = useState([]);
    // const [totalBundles, setTotalBundles] = useState(0);
    const [totalBundlesRevenue, setTotalBundlesRevenue] = useState(0);
    // const [avgItemPerBundle, setAvgItemPerBundle] = useState(0);
    const [savePrice, setSavePrice] = useState(5) // in percentage
    const [savePrice1, setSavePrice1] = useState({
        strong: [2],
        medium: [4],
        low: [7]
    }) // in percentage
    const [performanceRevenue, setPerformanceRevenue] = useState({
        highRevenue: {
            percentage: 0,
            bundles: 0
        },
        mediumRevenue: {
            percentage: 0,
            bundles: 0
        },
        lowRevenue: {
            percentage: 0,
            bundles: 0
        }
    })
    // const [searchQueryForItemsets, setSearchQueryForItemsets] = useState('');
	// const [sortBy, setSortBy] = useState('');
    // const [avgConversionRate, setAvgConversionRate] = useState(0)


    function generateBundleNameFromProducts(items, maxWords = 5) {
        // Combine all titles
        const combinedTitle = items
            .map(item => item?.title?.replace(/\s*[-–—]\s*(main|default|sku.*)?$/i, '').trim())
            .join(' ');

        // Split into words
        const words = combinedTitle
            .split(/\s+/)
            .map(w => w.toLowerCase())
            .filter(w => w.length > 2) // Filter out very short words like 'on', 'to', 'of', etc.
            .filter(w => !['for', 'the', 'and', 'with', 'a', 'an', 'in', 'or'].includes(w)); // Remove common stop words

        // Take up to maxWords unique words in original case (find from combinedTitle)
        const uniqueWords = [];
        for (const word of words) {
            // Find original word from combinedTitle (case sensitive)
            const regex = new RegExp(`\\b${word}\\b`, 'i');
            const match = combinedTitle.match(regex);
            if (match && !uniqueWords.includes(match[0])) {
                uniqueWords.push(match[0]);
            }
            if (uniqueWords.length >= maxWords) break;
        }

        return uniqueWords.join(' ');
    }

    const applyFilterForItemSets = () => {
		let filtered = [...withoutFilterProductBundles];
		const query = searchQueryForItemsets.toLowerCase().trim();

		// 1. Search filter
		if (query) {
			filtered = filtered.filter((item) => {
				const items = [...item.antecedents, ...item.consequent];
				const isSKU = items.some((sku) => sku?.sku.toLowerCase() === query);
				const isProductName = items.some((sku) =>
					sku?.product_title?.toLowerCase().includes(query)
				);
				return isSKU || isProductName;
			});
		}

		let newFilter = [...filtered];

		// 2. Sort correctly for all cases
		switch (sortBy) {
			case 'hl': // High lift
				newFilter = [...newFilter].sort((a, b) => Number(b.lift) - Number(a.lift));
				break;
			case 'll': // Low lift
				newFilter = [...newFilter].sort((a, b) => Number(a.lift) - Number(b.lift));
				break;
			case 'hs': // High days
				newFilter = [...newFilter].sort((a, b) => b.support - a.support);
				break;
			case 'ls': // Low days
				newFilter = [...newFilter].sort((a, b) => a.support - b.support);
				break;
			case 'hc': // High days
				newFilter = [...newFilter].sort((a, b) => b.confidence - a.confidence);
				break;
			case 'lc': // Low days
				newFilter = [...newFilter].sort((a, b) => a.confidence - b.confidence);
				break;
			default:
				break;
		}

		setProductBundles(newFilter);
	};



	useEffect(() => {
		applyFilterForItemSets();
	}, [searchQueryForItemsets, sortBy, withoutFilterProductBundles])

    useEffect(() => {
        if (productBundlesData.length > 0) {
            let totalRevenue = 0;
            const seenSkuCombos = new Set();

            const newData = productBundlesData.map((data) => {
                data["totalPurchasedTogether"] = Math.round(data.support * totalTransactions);
                data["antecedentPurchasedTogether"] = Math.round(data.antecedent_support * totalTransactions);
                data["consequentPurchasedTogether"] = Math.round(data.consequent_support * totalTransactions);

                data["totalAntecedentsPurchaseTogether"] = Math.round(data.antecedent_support * totalTransactions);
                data["totalConsequentsPurchaseTogether"] = Math.round(data.consequent_support * totalTransactions);

                data["totalPurchasedTogetherPercentage"] = ((Math.round(data.support * totalTransactions) / totalTransactions) * 100);

                let totalIncome = 0;
                let totalSellingPrice = 0;
                let productsTitle = [];
                let allSku = [];

                data.antecedents?.forEach((income) => {
                    totalIncome += Number(income.currentTotalPrice || 0);
                    totalSellingPrice += Number(income.selling_price || 0);
                    productsTitle.push({ title: income.product_title });
                    allSku.push(income.sku);
                });

                data.consequent?.forEach((income) => {
                    totalIncome += Number(income.currentTotalPrice || 0);
                    totalSellingPrice += Number(income.selling_price || 0);
                    productsTitle.push({ title: income.product_title });
                    allSku.push(income.sku);
                });

                data["productBundlesName"] = generateBundleNameFromProducts(productsTitle);
                data["totalPrice"] = totalSellingPrice;
                let savePriceNumber = 0;
                let percentageConfidence = formatConfidence(data.confidence)
                // console.log(formatConfidence(data.confidence),"confgsssss")
                if(percentageConfidence >= 60){
                    let index = Math.floor(Math.random() * 2);
                    savePriceNumber = savePrice1.strong[0]
                }else if(percentageConfidence >= 30 ){
                    let index = Math.floor(Math.random() * 3);
                    savePriceNumber = savePrice1.medium[0]
                }else{
                    let index = Math.floor(Math.random() * 5);
                    savePriceNumber = savePrice1.low[0]
                }
                data["bundlePrice"] = (totalSellingPrice - ((totalSellingPrice * savePriceNumber) / 100)).toFixed(2);
                data["savePrice"] = totalSellingPrice - data["bundlePrice"];
                data["savePercentage"] = savePriceNumber;

                data["totalIncomeTogether"] = totalIncome;
                totalRevenue += totalIncome;
                data["liftPercentage"] = formatSupport(((data.lift - 1)));
                data["conversionRate"] = ((Math.round(data.support * totalTransactions) / totalTransactions) * 100).toFixed(2);

                const rawAOV = totalIncome / data.totalPurchasedTogether || 0;
                data["AOV"] = parseFloat(rawAOV.toFixed(2));

                // let liftScore = (data.lift / customeValueData.maxLift) * 100;
                // let AOVScore = (data.AOV / customeValueData.maxAov) * 100;
                // let supportScore = (data.support / customeValueData.maxSupport) * 100;

                // let CustomerValue = (
                //     (liftScore * 0.4) +
                //     (AOVScore * 0.3) +
                //     (supportScore * 0.3)
                // ).toFixed(2);

                // data["CustomerValue"] = CustomerValue;
                data["allSku"] = allSku;

                return data;
            })
                .filter((data) => data.totalPurchasedTogether !== 0)
                .filter((data) => {
                    // Normalize allSku: sort & join
                    const skuKey = data.allSku.slice().sort().join(",");
                    if (seenSkuCombos.has(skuKey)) {
                        return false; // duplicate
                    }
                    seenSkuCombos.add(skuKey);
                    return true; // unique
                });

            // Sort descending by confidence
            newData.sort((a, b) => {
                const confidenceDiff = Number(b.confidence) - Number(a.confidence);
                if (confidenceDiff !== 0) return confidenceDiff;

                const liftDiff = Number(b.lift) - Number(a.lift);
                if (liftDiff !== 0) return liftDiff;

                
            });

            // Assign rank based on sorted order (1-based)
            newData.forEach((data, index) => {
                data.rank = index + 1;
            });


            // Step 1: Pehle map ke baad filtered final data ka use karo
            const processedBundles = productBundlesData.map((data) => {
                // ... [aapka jo processing logic hai usi ke according]
                data["conversionRate"] = ((Math.round(data.support * totalTransactions) / totalTransactions) * 100).toFixed(2);
                return data;
            }).filter((data) => data.totalPurchasedTogether !== 0);

            // Step 2: Average Conversion Rate nikaalna
            const totalConversion = processedBundles.reduce((sum, item) => sum + parseFloat(item.conversionRate), 0);
            const avgConversionRate = (totalConversion / processedBundles.length).toFixed(2);
            dispatch(setAvgConversionRate(avgConversionRate))



            const totalItems = newData.reduce((sum, bundle) => {
                const antecedentsCount = bundle.antecedents ? bundle.antecedents.length : 0;
                const consequentsCount = bundle.consequent ? bundle.consequent.length : 0;
                return sum + antecedentsCount + consequentsCount;
            }, 0);


            let highRevenue = ((totalRevenue * 40) / 100);
            let mediumRevenue = ((totalRevenue * 25) / 100);
            let lowRevenue = ((totalRevenue * 40) / 100);
            let highCount = 0;
            let mediumCount = 0;
            let lowCount = 0;


            newData.map((data) => {
                if (data.totalIncomeTogether > highRevenue) {
                    highCount++;
                } else if (data.totalIncomeTogether > mediumRevenue) {
                    mediumCount++
                } else {
                    lowCount++
                }
            });
            // console.log(highRevenue,totalRevenue,mediumRevenue,lowRevenue,newData,"newData")
            const performace = {
                highRevenue: {
                    percentage: ((highCount / newData.length) * 100),
                    bundles: highCount
                },
                mediumRevenue: {
                    percentage: ((mediumCount / newData.length) * 100),
                    bundles: mediumCount
                },
                lowRevenue: {
                    percentage: ((lowCount / newData.length) * 100),
                    bundles: lowCount
                }
            }

            // console.log(performace,"performace",highRevenue,mediumRevenue,totalRevenue)

            setPerformanceRevenue(performace)


            const averageItemsPerBundle = totalItems / newData.length;

            // console.log(totalItems,newData.length)

            dispatch(setAvgItemPerBundle(averageItemsPerBundle.toFixed(2)));
            setTotalBundlesRevenue(totalRevenue)
            dispatch(setTotalBundles(newData.length));
            setProductBundles(newData);
            setWithoutFilterProductBundles(newData);
        }else{
            setProductBundles([])
            setWithoutFilterProductBundles([]);
            dispatch(setTotalBundles(0))
            setTotalBundlesRevenue(0)
            dispatch(setAvgItemPerBundle(0))
            setPerformanceRevenue({
                highRevenue: {
                    percentage: 0,
                    bundles: 0
                },
                mediumRevenue: {
                    percentage: 0,
                    bundles: 0
                },
                lowRevenue: {
                    percentage: 0,
                    bundles: 0
                }
            })
            dispatch(setAvgConversionRate(0))
        }
    }, [productBundlesData])
    const itemsPerPage = 3;
    const [currentPage, setCurrentPage] = useState(1);

    const totalPages = Math.ceil((productsBundles?.length -1 || 0) / itemsPerPage);

    const startIndex = ((currentPage - 1) * itemsPerPage)+1;


    const currentData = productsBundles?.slice(startIndex, startIndex + itemsPerPage) || [];


    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(prev => prev + 1);
    };

    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage(prev => prev - 1);
    };



    return (
        <div id="resultsContainer">

            {
                totalBundles === 0 &&
                <div className="flex items-center justify-center h-64">
                <h1 className="text-xl text-gray-500 font-semibold">No Bundle Found</h1>
              </div>
            }

            {
                totalBundles > 0 &&
                <div className="config-carsd psas-6 mb-0 cstm_ResultsTest-radius rounded-none">
                {/* Enhanced Header with Performance Summary */}
                {/* <div class="container mx-auto px-4 py-8 max-w-7xl">
                    <div class="bg-white rounded-xl shadow-md p-6 mb-8 border-l-4 border-indigo-500">
                        <div class="flex flex-col md:flex-row justify-between items-start md:items-center">
                            <div>
                                <h1 class="text-2xl md:text-3xl font-bold text-gray-800 mb-2">Bundle Performance Dashboard</h1>
                                <p class="text-gray-600">Comprehensive analytics for your product bundles performance</p>
                            </div>
                            <div class="mt-4 md:mt-0 flex items-center space-x-4">
                                <div class="text-right">
                                    <p class="text-xs font-medium text-gray-500">REPORT PERIOD</p>
                                    <p class="text-sm font-medium text-indigo-600">Last 90 Days</p>
                                </div>
                                <button class="bg-indigo-50 hover:bg-indigo-100 text-indigo-700 px-4 py-2 rounded-lg text-sm font-medium transition-colors">
                                    <i class="fas fa-download mr-2"></i> Export Report
                                </button>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* Key Metrics Grid */}

                {/* <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
                    <div class="metric-card bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
                        <div class="flex justify-between">
                            <div>
                                <p class="text-sm font-medium text-gray-500 mb-1">Total Bundles</p>
                                <p class="mt-1 text-3xl font-semibold text-gray-900">{totalBundles}</p>
                            </div>
                            <div class="bg-blue-100 p-3 h-12 w-12 rounded-lg flex items-center justify-center">
                                <i class="fas fa-boxes text-blue-600 text-lg"></i>
                            </div>
                        </div>
                    </div>
                    <div class="metric-card bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
                        <div class="flex justify-between">
                            <div>
                                <p class="text-sm font-medium text-gray-500 mb-1">Avg. Item Per Bundles</p>
                                <p class="mt-1 text-3xl font-semibold text-gray-900">{avgItemPerBundle}</p>
                            </div>
                            <div class="bg-purple-100 p-3 h-12 w-12 rounded-lg flex items-center justify-center">
                                <i class="fas fa-chart-line text-purple-600 text-lg"></i>
                            </div>
                        </div>
                    </div>

                    <div class="metric-card bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
                        <div class="flex items-center justify-between">
                            <div>
                                <p class="text-sm font-medium text-gray-500 truncate">Avg. Support</p>
                                <p class="mt-1 text-3xl font-semibold text-gray-900">{avgConversionRate}%</p>
                            </div>
                            <div class="bg-red-100 p-3 rounded-lg">
                                <i class="fas fa-percentage text-red-600"></i>
                            </div>
                        </div>
                    </div>

                </div> */}
                {/* <div class="bg-white rounded-xl shadow-md p-6 mb-6 shine">
                    <div class="flex items-center mt-3 md:mt-0">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4 ">
                            <input
                                type="text"
                                placeholder="Search by SKU, Product Name"
                                value={searchQueryForItemsets}
                                onChange={(e) => {
                                	dispatch(setSearchQueryForItemsets(e.target.value))
                                }}
                                className="px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm w-full"
                            />
                            <select
                                value={sortBy}
                                onChange={(e) => dispatch(setSortBy(e.target.value))}
                                className="px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm w-full"
                            >
                                <option value="">Sort By</option>
                                <option value="hl">Highest Lift</option>
                                <option value="ll">Lowest Lift</option>
                                <option value="hs">Highest Support</option>
                                <option value="ls">Lowest Support</option>
                                <option value="hc">Highest Confidence</option>
                                <option value="lc">Lowest Confidence</option>
                            </select>
                        </div>
                    </div>
                </div> */}

                {
                    productsBundles && productsBundles.length > 0 &&
                    productsBundles.slice(0, 1).length > 0 && productsBundles.slice(0, 1).map((combo, index) => {
                        return <div class="bundle-combo-container rounded-2xl shadow-lg overflow-hidden mb-8 border border-shopify-primary/20">
                            <div class="p-6">
                                <div class="p flex justify-between items-center">
                                    <div>
                                        <h3 class="text-2xl font-bold text-gray-800 flex items-center">
                                          <span class="text-lg bg-green-100 text-green-800 px-2 py-0.5 rounded">#1</span>&nbsp;&nbsp; {combo.productBundlesName} 
                                        </h3>
                                        {/*<div class="flex items-center mt-1 mb-3 text-sm">
                                            &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp; Together purchased in {combo.totalPurchasedTogether} times of orders
                                        </div> */}
                                    </div>
                                    <div class="flex flex-col justify-between h-full">
                                        <div class="flex items-center space-x-2 justify-end">
                                        <i class="fas fa-bolt text-shopify-primary"></i>
                                        <span class="font-semibold">{formatConfidence(combo.confidence)}% Match Score</span>
                                      </div>
                                        <span
                                            className={`text-xs font-semibold uppercase tracking-wider inline-block px-2 py-1 rounded-full animates-spin-slow
                                            ${combo.confidence >= 0.6
                                            ? 'bg-green-100 text-green-700'
                                            : combo.confidence >= 0.3
                                                ? 'bg-yellow-100 text-yellow-800'
                                                : 'bg-red-100 text-red-700'}`}
                                        >
                                            {/* {combo.confidence >= 0.6
                                                ? 'Most Popular'
                                                : combo.confidence >= 0.3
                                                    ? 'Best Value'
                                                    : 'Weak'} */}
                                            {
                                                getBundleTags(combo.support,combo.confidence,combo.lift).join(" + ")
                                            }
                                        </span>
                                    </div>
                                </div>

                                <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                                    {
                                        [...combo.antecedents, ...combo.consequent].map((product, idx, arr) => (
                                            <React.Fragment key={idx}>
                                                <div class="bg-white p-5 rounded-xl shadow-sm border border-gray-100 product-image-hover">
                                                    <div class="relative h-48 w-full bg-gray-50 rounded-lg overflow-hidden mb-4">
                                                        <img src={product.image || "noimage.jpg"} alt="" class="w-full h-full object-contain p-4" />
                                                        <div class="absolute top-2 right-2 bg-shopify-primary text-white text-xs font-bold px-2 py-1 rounded-full">{idx + 1}</div>
                                                    </div>
                                                    <div>
                                                        <h4 class="font-bold text-gray-800 mb-1"> {product.product_title}</h4>
                                                        {/* <p class="text-xs text-gray-500 mb-2">Classic fit, 100% organic cotton</p> */}
                                                        <div class="flex justify-between items-center border-t mt-4">
                                                            <span class="text-shopify-primary font-bold  mt-4">{product.selling_price ? `$${product.selling_price}`: ""}</span>
                                                            
                                                        </div>
                                                    </div>
                                                    
                                                </div>


                                                {idx < arr.length - 1 && (
                                                    <div class="flex items-center justify-center">
                                                        <div class="text-center hidden md:block">
                                                            <div class="w-12 h-12 rounded-full bg-shopify-primary flex items-center justify-center text-white mx-auto mb-2">
                                                                <i class="fas fa-plus"></i>
                                                            </div>
                                                            <p class="text-xs text-gray-500">Together purchased<br />in <span class="font-bold">{combo.totalPurchasedTogether} times</span> of orders</p>
                                                        </div>
                                                        <div class="md:hidden w-full border-t-2 border-dashed border-gray-200 my-4"></div>
                                                    </div>
                                                )}
                                            </React.Fragment>
                                        ))
                                    }

                                </div>

                                <div class="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
                                    {/* <div class="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
                                        <div class="flex items-center">
                                            <div class="bg-shopify-light w-10 h-10 rounded-full flex items-center justify-center mr-3">
                                                <i class="fas fa-shopping-cart text-shopify-primary"></i>
                                            </div>
                                            <div>
                                                <p class="text-xs text-gray-500">Total Revenue</p>
                                                <p class="font-bold">${combo.totalIncomeTogether.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                            </div>
                                        </div>
                                    </div> */}
                                    {/* <div class="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
                                        <div class="flex items-center">
                                            <div class="bg-shopify-light w-10 h-10 rounded-full flex items-center justify-center mr-3">
                                                <i class="fas fa-money-bill-wave text-shopify-primary"></i>
                                            </div>
                                            <div>
                                                <p class="text-xs text-gray-500">Avg. Order Value</p>
                                                <p class="font-bold">${combo.AOV.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                            </div>
                                        </div>
                                    </div> */}
                                   {/* <div class="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
                                        <div class="flex items-center">
                                            <div class="bg-shopify-light w-10 h-10 rounded-full flex items-center justify-center mr-3">
                                            <i class="fas fa-level-up-alt mr-1"></i>
                                            </div>
                                            <div>
                                                <p class="text-xs text-gray-500"> Lift When Paired</p>
                                                <p class="font-bold">{formatLift(combo.lift)}</p>
                                            </div>
                                        </div>
                                    </div>*/}
                                    {/* <div class="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
                                        <div class="flex items-center">
                                            <div class="bg-shopify-light w-10 h-10 rounded-full flex items-center justify-center mr-3">
                                                <i class="fas fa-percentage text-shopify-primary"></i>
                                            </div>
                                            <div>
                                                <p class="text-xs text-gray-500">Conversion Rate</p>
                                                <p class="font-bold">{combo.conversionRate}%</p>
                                            </div>
                                        </div>
                                    </div> */}
                                    {/* <div class="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
                                        <div class="flex items-center">
                                            
                                            <div>
                                                <p class="text-xs text-gray-500">Lift</p>
                                                <p class="font-bold">{formatLift(combo.lift)}</p>
                                            </div>
                                        </div>
                                    </div> */}
                                    {/* <div class="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
                                    <div class="flex items-center">
                                        <div class="bg-shopify-light w-10 h-10 rounded-full flex items-center justify-center mr-3">
                                            <i class="fas fa-tags text-shopify-primary"></i>
                                        </div>
                                        <div>
                                            <p class="text-xs text-gray-500">Discount Potential</p>
                                            <p class="font-bold">8-15% Off</p>
                                        </div>
                                    </div>
                                </div> */}
                                </div>

                                <div class=" pt-6 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center">
                                    <div class="mb-4 md:mb-0">
                                        <p class="text-gray-600">Bundle Price:</p>
                                        <p class="text-2xl font-bold text-shopify-darker">${combo.bundlePrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} 
                                        {combo.savePercentage !== 0 && (
                                            <>
                                                <span className="text-base font-normal line-through text-gray-500">
                                                ${combo.totalPrice.toLocaleString('en-US', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })}
                                                </span>{' '}
                                                <span className="text-green-600 text-sm">
                                                (Save {combo.savePercentage}%)
                                                </span>
                                            </>
                                            )}
                                        </p>
                                    </div> 
                                    <div class="mb-4 md:mb-0">
                                        <p class="text-gray-600">Support</p>
                                        <p class="text-2xl font-bold text-shopify-darker">
                                        {formatSupport(combo.support)}%
                                        </p>
                                    </div>
                                    <div class="mb-4 md:mb-0">
                                        <p class="text-gray-600">Lift When Paired</p>
                                        <p class="text-2xl font-bold text-shopify-darker">
                                        {formatLift(combo.lift)}
                                        </p>
                                    </div>
                                    <div class="mb-4 md:mb-0">
                                        <p class="text-gray-600">Antecedent Support</p>
                                        <p class="text-2xl font-bold text-shopify-darker">
                                        {formatSupport(combo.antecedent_support)}%
                                        </p>
                                        <span class="w-auto text-xs bg-indigo-100 text-indigo-800 px-2 py-1 rounded-full inline-flex items-center gap-0.5"><i class="fas fa-users mr-1"></i><span class="font-bold ml-1">{combo.antecedentPurchasedTogether} </span> bought</span>

                                    </div>
                                    <div class="mb-4 md:mb-0">
                                        <p class="text-gray-600">Consequent Support</p>
                                        <p class="text-2xl font-bold text-shopify-darker">
                                        {formatSupport(combo.consequent_support)}%
                                        </p>
                                       <span class="w-auto text-xs bg-indigo-100 text-indigo-800 px-2 py-1 rounded-full inline-flex items-center gap-0.5"><i class="fas fa-users mr-1"></i><span class="font-bold ml-1">{combo.consequentPurchasedTogether} </span> bought</span>
                                    </div>
                                    {/* <div class="flex space-x-3">
                                        <button class="px-5 py-3 bg-shopify-primary hover:bg-shopify-dark text-white font-bold rounded-lg flex items-center transition duration-300">
                                            <i class="fas fa-tags mr-2"></i> Create Bundle Discount
                                        </button>
                                        <button class="px-5 py-3 border border-shopify-primary text-shopify-primary hover:bg-shopify-light font-bold rounded-lg flex items-center transition duration-300">
                                            <i class="fas fa-eye mr-2"></i> Preview
                                        </button>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    })

                }


                {/* Main Dashboard Sections */}
                <div class="grid grid-cols-1  mb-8">
                    {/* Revenue Overview */}
                    <div class="lg:col-span-2 bg-white rounded-xl shadow-sm pss-6">
                        <div className="lg:col-span-2 bg-white rounded-xl p-6 synergy-card">
                            <div className="flex items-center justify-between mb-6">
                                <h2 className="text-xl font-bold text-gray-800"> <i class="fas fa-boxes text-shopify-primary mr-3"></i> Other Product Bundles</h2>
                                {/* <div className="flex space-x-2">
                                    <button className="px-3 py-1 bg-blue-50 text-blue-600 rounded-lg text-sm font-medium active">
                                        Pairs
                                    </button>
                                    <button className="px-3 py-1 bg-gray-50 text-gray-600 rounded-lg text-sm font-medium">
                                        Trios
                                    </button>
                                    <button className="px-3 py-1 bg-gray-50 text-gray-600 rounded-lg text-sm font-medium">
                                        Quads+
                                    </button>
                                </div> */}
                            </div>


                            <div className="space-y-4" >
                                {

                                    productsBundles && productsBundles.length > 0 && currentData.length > 0 ? (
                                        currentData.map((combo, index) => (
                                            <div class="mt-8 p-4 bg-shopify-light rounded-lg border border-shopify-primary">
                                                <div class="p flex justify-between items-center">
                                                    <h4 class="font-bold text-gray-800 mb-4 flex items-center">
                                                        <span class="text-xs bg-indigo-100 text-indigo-800 px-2 py-0.5 rounded">#{combo.rank}</span> &nbsp;&nbsp; {combo.productBundlesName}
                                                    </h4>
                                                    
                                                    <div class="flex flex-col justify-between h-full">
                                                        <div class="flex items-center space-x-2 justify-end"><i class="fas fa-bolt text-shopify-primary"></i><span class="font-semibold">{formatSupport(combo.confidence)}% Match Score</span></div>
                                                        
                                                    
                                                    
                                                        {/* <span class="text-sm font-medium text-gray-700 mr-3">Conversion Rate: {combo.conversionRate}%</span> */}
                                                        <span
                                                            className={`text-xs font-semibold uppercase tracking-wider inline-block px-2 py-1 rounded-full
                                                ${combo.confidence === 1
                                                                    ? 'bg-green-100 text-green-700'
                                                                    : combo.confidence > 0.6
                                                                        ? 'bg-yellow-100 text-yellow-800'
                                                                        : 'bg-red-100 text-red-700'
                                                                }`}
                                                        >
                                                            {/* {combo.confidence >= 0.6
                                                                ? 'Most Popular'
                                                                : combo.confidence >= 0.3
                                                                    ? 'Best Value'
                                                                    : 'Weak'} */}
                                                                    {
                                                getBundleTags(combo.support,combo.confidence,combo.lift).join(" + ")
                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="flex flex-col md:flex-row gap-6">
                                                    <div class="md:w-2/3">
                                                        <div class="flex flex-wrap items-center mb-2">
                                                            {[...combo.antecedents, ...combo.consequent].map((product, idx, arr) => (
                                                                <React.Fragment key={idx}>
                                                                    <span className="inline-block bg-white border border-gray-300 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2 flex items-center">
                                                                        {/* Show image instead of colored dot */}
                                                                        <img
                                                                            src={product.image || "noimage.jpg"}
                                                                            alt={product.product_title}
                                                                            className="w-5 h-5 rounded-full mr-2 object-cover"
                                                                        />
                                                                        {product.product_title}
                                                                    </span>
                                                                    {/* '+' between items, not after last */}
                                                                    {idx < arr.length - 1 && (
                                                                        <i className="fas fa-plus text-gray-400 mx-2 mb-2"></i>
                                                                    )}
                                                                </React.Fragment>
                                                            ))}
                                                            {/* <span class="inline-block bg-white border border-gray-300 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2 flex items-center">
                                                <span class="w-4 h-4 rounded-full bg-shopify-primary mr-2"></span> Organic Cotton T-Shirt
                                            </span> */}
                                                            {/* <i class="fas fa-plus text-gray-400 mx-2 mb-2"></i>
                                            <span class="inline-block bg-white border border-shopify-primary rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2 flex items-center">
                                                <span class="w-4 h-4 rounded-full bg-shopify-primary mr-2"></span> Organic Cotton Shorts
                                            </span> */}
                                                        </div>
                                                        {/* <div class="mt-6 bg-blue-50 rounded-lg p-3 mt-5">
                                                        <div class="flex items-start">
                                                            <div class="bg-blue-100 text-blue-800 p-1 rounded-full mr-2">
                                                                <i class="fas fa-bolt text-xs"></i>
                                                            </div>
                                                            <div>
                                                                <p class="text-xs text-blue-800">This bundle helps clear 3 slow-moving inventory items while maintaining healthy margins.</p>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                            <hr/>

                                                        <div class="flex flex-col md:flex-row justify-between items-center mt-9">
                                                            <div>
                                                                <p class="text-gray-600 text-sm">Bundle Price:</p>
                                                                <p class="text-xl font-bold text-shopify-darker">${combo.bundlePrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}  

                                                                    {combo.savePercentage !== 0 &&
                                                                        <>
                                                                            <span class="text-base font-normal line-through text-gray-500">${combo.totalPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span> <span class="text-green-600 text-sm">(Save {combo.savePercentage}%)</span>
                                                                        </>
                                                                    }
                                                                </p>
                                                            </div>
                                                            <div>
                                                                <p class="text-gray-600 text-sm"><i class="fas fa-users mr-1"></i> Purchases together</p>
                                                                <p class="text-xl font-bold text-shopify-darker">
                                                                    {combo.totalPurchasedTogether}
                                                                </p>
                                                            </div>
                                                            
                                                            
                                                            
                                                        </div>
                                                    
                                                        

                                                    </div>
                                                    <div class="md:w-1/3 border-l border-gray-200 pl-6">
                                                        {/* <div class="mb-4">
                                                        <div class="flex justify-between mb-1">
                                                            <span class="text-sm font-medium text-gray-700">Business Value</span>
                                                            <span class="text-sm font-medium text-gray-700">68%</span>
                                                        </div>
                                                        <div class="w-full bg-gray-200 rounded-full h-2.5">
                                                            <div class="bg-indigo-600 h-2.5 rounded-full progress-bar" ></div>
                                                        </div>
                                                        <p class="text-xs text-gray-500 mt-1">Revenue, profit &amp; inventory impact</p>
                                                    </div> */}

                                                        {/*  <div className="mb-4">
                                                            <div className="flex justify-between mb-1">
                                                                <span className="text-sm font-medium text-gray-700">Customer Value</span>
                                                                <span className="text-sm font-medium text-gray-700">{combo.CustomerValue}%</span>
                                                            </div>
                                                            <div className="w-full bg-gray-200 rounded-full h-2.5">
                                                                <div
                                                                    className="bg-green-500 h-2.5 rounded-full progress-bar"
                                                                    style=
                                                                ></div>
                                                            </div>
                                                            <p className="text-xs text-gray-500 mt-1">Satisfaction &amp; convenience score</p>
                                                        </div>
                                                       <div className="mb-4">
                                                            <div className="flex justify-between mb-1">
                                                                <span className="text-sm font-medium text-gray-700">Confidence</span>
                                                                <span className="text-sm font-medium text-gray-700">{formatSupport(combo.confidence)}%</span>
                                                            </div>
                                                        </div>
                                                         <div className="mb-4">
                                                            <div className="flex justify-between mb-1">
                                                                <span className="text-sm font-medium text-gray-700">Lift</span>
                                                                <span className="text-sm font-medium text-gray-700">{formatLift(combo.lift)}</span>
                                                            </div>
                                                        </div> */}
                                                            {/* <div className="text-sm text-gray-600">
                                                                Total Revenue:{' '}
                                                                <span className="font-semibold text-gray-800">${combo.totalIncomeTogether.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                            </div> */}
                                                            {/* Avg. order value */}
                                                            {/* <div className="text-sm text-gray-600">
                                                                Avg. order value:{' '}
                                                                <span className="font-semibold text-gray-800">${combo.AOV.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                            </div> */}

                                                            {/* Lift when paired */}
                                                            
                                                            
                                                            
                                                         <div>

                                                   


                                                </div>   
                                                
                                                <div class="flex flex-col md:flex-row justify-between items-center mt-4">
                                                        
                                                            <div>
                                                                    <p class="text-gray-600 text-sm"> Support</p>
                                                                    <p class="text-xl font-bold text-shopify-darker">
                                                                        {formatSupport(combo.support)}%
                                                                    </p>
                                                                    
                                                            </div>
                                                            <div>
                                                                <p class="text-gray-600 text-sm">Lift when paired</p>
                                                                <p class="text-xl font-bold text-shopify-darker text-right">
                                                                    {formatLift(combo.lift)}
                                                                </p>
                                                               
                                                            </div>
                                                        </div>
                                                        <br />
                                                        <div class="flex flex-col md:flex-row justify-between items-center mt-4">
                                                        
                                                            <div>
                                                                    <p class="text-gray-600 text-sm">Antecedent Support</p>
                                                                    <p class="text-xl font-bold text-shopify-darker">
                                                                        {formatSupport(combo.antecedent_support)}%
                                                                    </p>
                                                                    <div class="w-auto text-xs bg-indigo-100 text-indigo-800 px-2 py-1 rounded-full inline-flex items-center gap-0.5">
                                                                        <i class="fas fa-users mr-1"></i> {combo.antecedentPurchasedTogether} bought
                                                                    </div>
                                                            </div>
                                                            <div>
                                                                <p class="text-gray-600 text-sm">Consequent Support</p>
                                                                <p class="text-xl font-bold text-shopify-darker text-right">
                                                                    {formatSupport(combo.consequent_support)}%
                                                                </p>
                                                                <div className="text-right">
                                                                        <div class="w-auto text-xs bg-indigo-100 text-indigo-800 px-2 py-1 rounded-full inline-flex items-center gap-0.5">
                                                                            <i class="fas fa-users mr-1"></i> {combo.consequentPurchasedTogether} bought
                                                                        </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>





                                                <br />
                                                
                                            </div>
                                        ))
                                    ) : (
                                        <div className="text-center text-gray-500 py-10 text-sm">No Records Found.</div>
                                    )

                                }
                                { totalPages > 1 && productsBundles && productsBundles.length > itemsPerPage && (
                                    <div className="flex justify-center mt-6 space-x-4">
                                        <button
                                            onClick={handlePrev}
                                            disabled={currentPage === 1}
                                            className={`px-4 py-2 text-sm rounded ${currentPage === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-indigo-500 text-white hover:bg-indigo-600'}`}
                                        >
                                            Previous
                                        </button>
                                        <span className="text-sm text-gray-600 self-center">Page {currentPage} of {totalPages}</span>
                                        <button
                                            onClick={handleNext}
                                            disabled={currentPage === totalPages}
                                            className={`px-4 py-2 text-sm rounded ${currentPage === totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-indigo-500 text-white hover:bg-indigo-600'}`}
                                        >
                                            Next
                                        </button>
                                    </div>
                                )}
                            </div>



                            <div className="space-y-4" style={{ display: "none" }}>
                                {productsBundles && productsBundles.length > 0 ? (
                                    currentData.map((combo, index) => (
                                        <div
                                            key={index}
                                            className=""
                                        >
                                            <div className=" rounded-2xl shadow-md p-4 flex-1 space-y-4">
                                                {/* Header */}
                                                <div className="flex flex-wrap items-center gap-3 text-sm">
                                                    <span className="bg-purple-100 text-red-700 font-bold text-xs px-2 py-1 rounded-full">
                                                        #{combo.rank}
                                                    </span>
                                                    <span className="text-gray-600">{combo.totalPurchasedTogether} purchases together</span>
                                                    <span className="text-gray-600">Total Price: ${combo.totalPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                    <span className="text-gray-600">Conversion rate: {combo.conversionRate}%</span>
                                                    <span className="text-gray-600">Total Revenue: ${combo.totalIncomeTogether.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                </div>

                                                {/* Products */}
                                                <div className="flex flex-wrap gap-2">
                                                    {[...combo.antecedents, ...combo.consequent].map((product, idx) => (
                                                        <span
                                                            key={idx}
                                                            className="bg-gray-100 text-gray-800 text-sm px-3 py-1.5 rounded-full flex items-center"
                                                        >
                                                            <img
                                                                src={product.image || "noimage.jpg"}
                                                                alt={product.product_title}
                                                                className="w-4 h-4 rounded-full mr-2"
                                                            />
                                                            {product.product_title}
                                                        </span>
                                                    ))}
                                                </div>

                                                {/* Insights */}
                                                <div className="flex flex-wrap items-center gap-4 text-sm">
                                                    <span className="text-green-600 font-medium">
                                                        <i className="fas fa-arrow-up mr-1"></i>
                                                        {combo.liftPercentage}% lift when paired
                                                    </span>
                                                    <span className="text-gray-600">
                                                        Avg. order value: <span className="font-medium">${combo.AOV}</span>
                                                    </span>
                                                    <span className="text-gray-600">
                                                        Product Bundle: <span className="font-medium">{combo.productBundlesName}</span>
                                                    </span>
                                                </div>

                                                {/* Pricing */}
                                                <div className="flex flex-wrap items-center gap-4 text-sm">
                                                    <span className="text-gray-600">
                                                        Total Price: <span className="font-medium">${combo.totalPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                    </span>
                                                    <span className="text-gray-600">
                                                        Bundle Price: <span className="font-medium">${combo.bundlePrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                    </span>
                                                    <span className="text-gray-600">
                                                        You Save: <span className="text-green-600 font-medium">{combo.savePercentage}%</span>
                                                    </span>
                                                </div>

                                                {/* Confidence Badge */}
                                                <div>
                                                    <span
                                                        className={`text-xs font-semibold uppercase tracking-wider inline-block px-2 py-1 rounded-full
        ${combo.confidence >= 0.6
                                                                ? 'bg-green-100 text-green-700'
                                                                : combo.confidence >= 0.3
                                                                    ? 'bg-yellow-100 text-yellow-800'
                                                                    : 'bg-red-100 text-red-700'}`}
                                                    >
                                                        {/* {combo.confidence >= 0.6
                                                            ? 'Most popular'
                                                            : combo.confidence >= 0.3
                                                                ? 'Best value'
                                                                : 'Weak'} */}
                                                                {
                                                getBundleTags(combo.support,combo.confidence,combo.lift).join(" s+ ")
                                            }
                                                    </span>
                                                </div>
                                            </div>

                                            {/* <button className="ml-4 px-3 py-1.5 bg-blue-50 text-blue-600 rounded-lg text-sm font-medium hover:bg-blue-100">
                                                Create Bundle
                                            </button> */}
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-center text-gray-500 py-10 text-sm">No results found.</div>
                                )}
                                {productsBundles && productsBundles.length > itemsPerPage && (
                                    <div className="flex justify-center mt-6 space-x-4">
                                        <button
                                            onClick={handlePrev}
                                            disabled={currentPage === 1}
                                            className={`px-4 py-2 text-sm rounded ${currentPage === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-indigo-500 text-white hover:bg-indigo-600'}`}
                                        >
                                            Previous
                                        </button>
                                        <span className="text-sm text-gray-600 self-center">Page {currentPage} of {totalPages}</span>
                                        <button
                                            onClick={handleNext}
                                            disabled={currentPage === totalPages}
                                            className={`px-4 py-2 text-sm rounded ${currentPage === totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-indigo-500 text-white hover:bg-indigo-600'}`}
                                        >
                                            Next
                                        </button>
                                    </div>
                                )}
                            </div>

                            {/* <div className="mt-6 pt-4 border-t border-gray-100 text-center">
                                <button className="text-blue-600 hover:text-blue-800 font-medium text-sm">
                                    View All Combinations <i className="fas fa-chevron-right ml-1"></i>
                                </button>
                            </div> */}
                        </div>
                    </div>

                    {/* Bundle Performance */}
                    {
                        productsBundles.length > 0 &&
                        <div class="rounded-xl shadow-sm px-6">
                            {/* <div class="flex justify-between items-center mb-6">
                            <h2 class="text-lg font-bold text-gray-800">Top Performing Bundles</h2>
                            <select class="bg-gray-100 border-0 text-gray-700 text-xs rounded-lg px-2 py-1">
                                <option>By Revenue</option>
                                <option>By Profit</option>
                                <option>By Volume</option>
                            </select>
                        </div> */}
                            {/* <div class="space-y-4">
                                
                                <div class="p-3 bg-gray-50 rounded-lg">
                                    <div class="flex items-center justify-between mb-1">
                                        <h3 class="font-medium text-gray-800">{`High Revenue (>40%)`}</h3>
                                        <span class="text-xs bg-indigo-100 text-indigo-800 px-2 py-0.5 rounded">{performanceRevenue.highRevenue.bundles} Bundles</span>
                                    </div>
                                    <div class="flex justify-between text-sm">
                                        <span class="text-gray-500">Generating bundule revenue</span>
                                        <span class="font-medium text-green-600">{performanceRevenue.highRevenue.percentage}% </span>
                                    </div>
                                    <div class="w-full bg-gray-200 rounded-full h-1.5 mt-2">
                                        <div class="bg-indigo-600 h-1.5 rounded-full" style={{ width: `${performanceRevenue.highRevenue.percentage}%` }}></div>
                                    </div>
                                </div>

                                <div class="p-3 bg-gray-50 rounded-lg">
                                    <div class="flex items-center justify-between mb-1">
                                        <h3 class="font-medium text-gray-800">{`Medium Revenue (25-40%)`}</h3>
                                        <span class="text-xs bg-blue-100 text-blue-800 px-2 py-0.5 rounded">{performanceRevenue.mediumRevenue.bundles} Bundles</span>
                                    </div>
                                    <div class="flex justify-between text-sm">
                                        <span class="text-gray-500">Generating bundule revenue</span>
                                        <span class="font-medium text-green-600">{performanceRevenue.mediumRevenue.percentage}%</span>
                                    </div>
                                    <div class="w-full bg-gray-200 rounded-full h-1.5 mt-2">
                                        <div class="bg-blue-600 h-1.5 rounded-full" style={{ width: `${performanceRevenue.mediumRevenue.percentage}%` }}></div>
                                    </div>
                                </div>

                                <div class="p-3 bg-gray-50 rounded-lg">
                                    <div class="flex items-center justify-between mb-1">
                                        <h3 class="font-medium text-gray-800">{`Low Revenue (<25%)`}</h3>
                                        <span class="text-xs bg-purple-100 text-purple-800 px-2 py-0.5 rounded">{performanceRevenue.lowRevenue.bundles} Bundles</span>
                                    </div>
                                    <div class="flex justify-between text-sm">
                                        <span class="text-gray-500">Generating bundule revenue</span>
                                        <span class="font-medium text-green-600">{performanceRevenue.lowRevenue.percentage}% </span>
                                    </div>
                                    <div class="w-full bg-gray-200 rounded-full h-1.5 mt-2">
                                        <div class="bg-purple-600 h-1.5 rounded-full" style={{ width: `${performanceRevenue.lowRevenue.percentage}%` }}></div>
                                    </div>
                                </div>


                            </div> */}
                        </div>
                    }
                </div>
            </div>
            }
        </div>
    );
};

export default ProductBundles;
